import type { ReactNode, SVGProps } from "react";

export function NewAccountIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="13"
			viewBox="0 0 15 13"
			width="15"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M7.99051 10.8163H2.45551C1.90121 10.8163 1.6042 10.5991 1.21224 10.188C0.820294 9.77693 0.600098 9.21935 0.600098 8.63795V2.79224C0.600098 2.21085 0.820294 1.65327 1.21224 1.24216C1.6042 0.831055 2.1358 0.600098 2.6901 0.600098H11.0501C11.6044 0.600098 12.136 0.831055 12.528 1.24216C12.9199 1.65327 13.1401 2.21085 13.1401 2.79224V5.6001"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M0.600098 4.3501H12.7251"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M9.7251 9.8501H14.2251"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M11.9751 12.1001V7.6001"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M3.604 8.1001H3.6065"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M6.6001 8.1001H8.1001"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
		</svg>
	);
}
